export default __webpack_public_path__ + "8b6d7b8fd867e96f30d31c5ff0deae29.svg";